import { ID } from './id';
import { RelationshipUpdate } from './relationship';
import { UpdateTask } from './task';

export enum TaskListItemTypes {
  Root = 'root',
  LifeArea = 'lifeArea',
  Goal = 'goal',
  Priority = 'Priority',
  Date = 'date',
  DayPart = 'dayPart',
  Tag = 'tag',
  Task = 'task',
  Type = 'type',
  NewTask = 'newTask',
  Section = 'section',
}

export const rootId = 'root';

export type RootId = typeof rootId;

export type ReorderItem = {
  id: ID;
  type: TaskListItemTypes;
  children?: ID[];
};

export type TaskListTreeItem = ReorderItem & {
  name: string;
  isFolder?: boolean;
};

export type ReorderSectionUpdate = {
  id: ID;
  taskSorting: ID[];
};

export type ReorderResult = {
  updatedSections: ReorderSectionUpdate[];
  updatedTasks: UpdateTask[];
  relationshipUpdates?: RelationshipUpdate[];
};
